import React from 'react';
const GraphLoader = () => {
    return (
        <div className="graph-spinner-wrapper">
            <div className="graph-loader"></div>
        </div>
    );
};

export default GraphLoader;